import React from "react";

const CourseStructuredData = ({ course }) => {
  if (!course) return null;

  const displayPrice = course.is_discounted && course.discount_price 
    ? Number(course.discount_price) 
    : (course.price ? Number(course.price) : null);

  const siteUrl = process.env.NEXT_PUBLIC_SITE_URL?.replace(/\/$/, "") || "https://thesofar.org";
  const courseId = course.id || course._id || course.course_id || course.slug;
  const courseUrl = `${siteUrl}/courses/${courseId}`;

  const schema = {
    "@context": "https://schema.org",
    "@type": "Course",
    "name": course.title,
    "description": course.short_description || course.description || "SOFAR training certification course.",
    "provider": {
      "@type": "Organization",
      "name": "SOFAR",
      "sameAs": "https://thesofar.org"
    },
    "hasCourseInstance": {
      "@type": "CourseInstance",
      "courseMode": "online",
      "courseWorkload": "PT100H", // placeholder for educational hours
      "startDate": course.starting_date || undefined,
    },
    "offers": displayPrice ? {
      "@type": "Offer",
      "category": "Paid",
      "price": displayPrice,
      "priceCurrency": "INR",
      "url": courseUrl
    } : undefined
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default CourseStructuredData;
